import React from "react"
import { useMutation } from "@apollo/client"
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Grid,
  TextField,
  Typography,
} from "@mui/material"
import { gql } from "@apollo/client"

const UPDATE_AREA_DETAILS = gql`
  mutation updateArea($description: String!, $name: String!, $areaId: Int!) {
    update_area(
      where: { id: { _eq: $areaId } }
      _set: { description: $description, name: $name }
    ) {
      affected_rows
    }
  }
`

export default function AreaInfo({ area, onArchive }) {
  const [editArea, setEditArea] = React.useState(false)
  const [areaName, setAreaName] = React.useState(area.name)
  const [areaDescription, setAreaDescription] = React.useState(area.description)
  const [editAreaDetails] = useMutation(UPDATE_AREA_DETAILS)

  const handleSave = () => {
    editAreaDetails({
      variables: {
        description: areaDescription,
        name: areaName,
        areaId: area.id,
      },
    })
    setEditArea(false)
  }

  const handleDiscard = () => {
    setAreaName(area.name)
    setAreaDescription(area.description)
    setEditArea(false)
  }

  return (
    <>
      {editArea && (
        <Grid item xs={12}>
          <TextField
            label="Area Name"
            value={areaName}
            onChange={(e) => setAreaName(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Area Description"
            value={areaDescription}
            onChange={(e) => setAreaDescription(e.target.value)}
            fullWidth
            margin="normal"
            multiline
            rows={3}
          />
          <Button onClick={handleSave} variant="contained" sx={{ mr: 1 }}>
            Save
          </Button>
          <Button onClick={handleDiscard}>Discard</Button>
        </Grid>
      )}
      <Grid item xs={12}>
        <Card sx={{ maxWidth: 345 }}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {area.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {area.description}
            </Typography>
          </CardContent>
          <Collapse></Collapse>
          <CardActions>
            <Button size="small" onClick={() => setEditArea(true)}>
              Edit
            </Button>
            <Button size="small" color="error" onClick={onArchive}>
              Archive
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </>
  )
}
